import { ARDOQ_DEFAULT_LOCALE, localeCompare } from '@ardoq/locale';

type Primitive = string | number | undefined | boolean | null;

type RecursiveList<T> = Array<T | RecursiveList<T>>;

type RecursiveListOfOrValue<T> = RecursiveList<T> | T;

interface RecursiveDict {
  [key: string]: RecursiveListOfOrValue<RecursiveDict | Primitive>;
}

// Used by stateToHash to produce a content-addressable MD5 of LoadedState.
// Sort order must be locale-invariant: two users on different locales should
// derive the same hash for the same content. ARDOQ_DEFAULT_LOCALE pins the
// collation, so the hash depends on content alone.
export const flattenDict = (
  value: RecursiveListOfOrValue<Primitive | RecursiveDict>
): (string | number | boolean)[] => {
  if (!(value instanceof Object)) {
    return [value ?? ''];
  }

  if (Array.isArray(value)) {
    return value.flatMap(flattenDict);
  }

  return Object.entries(value)
    .sort(([a], [b]) => localeCompare(a, b, ARDOQ_DEFAULT_LOCALE))
    .flatMap(([key, value]) => [key, flattenDict(value)])
    .flat();
};
